import React from 'react'
import { baseUrl } from '../../config/clientsConfig'
import axios from 'axios'

const RoughPropertyService = {
    getRoughProperties: async (body) => {
        return axios.post(`${baseUrl}/rough-properties/list`, body);
    },
    createRoughProperty: async (propertyData) => {
     return axios.post(`${baseUrl}/rough-properties/create`, propertyData)
    },
    updateRoughProperty: async (propertyId, propertyData) => {
        return axios.put(`${baseUrl}/rough-properties/${propertyId}`, propertyData)
    },
    getRoughPropertyId: async (propertyId) => {
        return axios.get(`${baseUrl}/rough-properties/${propertyId}`);
    },

     createRoughUnits: async (propertyId , unitData) => {
            return axios.post(`${baseUrl}/rough-properties/${propertyId}/units`, unitData)
         },
        updateRoughUnits: async (propertyId , unitData) => {
            return axios.put(`${baseUrl}/rough-properties/${propertyId}/units`, unitData)
        },
        getRoughUnits: async  (body) => {
            return axios.post(`${baseUrl}/rough-properties/units` , body);
        },
        getPropertyMapPoints: async () => {
            return axios.get(`${baseUrl}/rough-properties/geo`);
        },
        searchProperties: async (body) => {
            return axios.post(`${baseUrl}/rough-properties/search` , body);
        },
        getRoughPropertyHistory : async (propertyId, params = {}) => {
            return axios.get(`${baseUrl}/rough-properties/${propertyId}/history`, { params });
        },
    
}

export default RoughPropertyService